import { Component, Injector, OnInit } from '@angular/core';
import {forkJoin, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {OrderInfo, ReturnsInfo} from 'src/app/models/models';
import {Store} from 'src/app/models/RestModels';
import {BaseComponent} from '../base/base.component';
import { PrinterService } from 'src/app/services/printer.service';

@Component({
	selector: 'app-print-return-receipt',
	templateUrl: './print-return-receipt.component.html',
	styleUrls: ['./print-return-receipt.component.css']
})
export class PrintReturnReceiptComponent extends BaseComponent implements OnInit
{
	order_info: OrderInfo | null = null;
	print_receipt:boolean = false;
	returns_info: ReturnsInfo | null = null;
	store: Store;
	usb_enabled:boolean = false;

	private printerService: PrinterService;

	constructor(public injector: Injector) {
		super(injector);
		this.printerService = injector.get(PrinterService);
	}

	ngOnInit(): void
	{
		this.printerService.resolvePreferences(this.rest.current_user);
		this.usb_enabled = this.printerService.isUsbPrintingEnabled();
		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap(params =>
			{
				this.print_receipt = params.has('print');
				this.setTitle('ReciboDevolucion-'+params.get('returns_id'));
				return forkJoin
				({
					returns_info: this.rest.returns_info.get( params.get('returns_id') ),
					store: this.rest.getStore( this.rest.current_user.store_id )
				});
			}),
			mergeMap((responses)=>
			{
				this.store =responses.store;
				this.returns_info = responses.returns_info;
				console.log('order_info', this.returns_info );
				return this.rest.order_info.get(this.returns_info.returns.order_id);
			})
		).subscribe((order_info) =>
		{
			console.log('order_info', order_info);
			this.order_info = order_info;

			if( this.print_receipt )
			{
				setTimeout(()=>{
					window.print()
					setTimeout(()=>window.close(),500)
				},1000);
			}
		},(error)=>{
			this.showError(error);
		});
	}

	justPrint()
	{
		window.print();
	}

	async printUsb(evt: Event): Promise<void>
	{
		try
		{
			if (!this.returns_info)
			{
				this.showError('Aun no se carga la devolucion.');
				return;
			}

			if (this.printerService.available_printers.length === 0)
			{
				const storeId = this.store?.id || this.returns_info?.store?.id || this.returns_info?.returns?.store_id || this.order_info?.store?.id || this.rest.current_user?.store_id;
				if (storeId)
				{
					const response = await this.rest.printer.search({
						limit: 9999,
						eq: { store_id: storeId },
						sort_order: ['name_ASC']
					}).toPromise();
					this.printerService.available_printers = response.data;
				}
			}

			this.printerService.resolvePreferences(this.rest.current_user);

			if (!this.printerService.isUsbPrintingEnabled())
			{
				this.showError('No hay impresora USB configurada. Configure la impresora en ajustes.');
				return;
			}

			const result = await this.printerService.printReturnReceipt({
				returns_info: this.returns_info,
				order_info: this.order_info,
				store: this.store || this.returns_info.store || this.order_info?.store,
				variant: this.returns_info.returns?.type === 'RETURN_MONEY' ? 'money' : 'coupon'
			}, 1, evt);

			if (!result.success)
			{
				this.showError('Error al imprimir: ' + result.message);
				return;
			}

			this.showSuccess('Devolucion impresa correctamente');
		}
		catch (error: any)
		{
			console.error('USB print error:', error);
			this.showError('Error al imprimir: ' + (error?.message || 'Error desconocido'));
		}
	}
}
